import { restHelper } from "../../@common/service/api"
import { UpdateTreeDragAndDropInput, ID } from "../../@common/types"

export interface SortingOutputMaterial {
  id: number
  title: string
  visible?: boolean
  selectable?: boolean
  children: SortingOutputMaterial[]
}

export interface PostSortingOutputMaterialInput {
  title: string
  parentId?: number
}

export interface PutSortingOutputMaterialTitleInput {
  id: number
  title: string
}

export interface DeleteSortingOutputMaterialInput {
  id: number
}

export const queries = {
  sortingOutputMaterials: `
    query sortingOutputMaterials($onlyVisible: Boolean) {
      sortingOutputMaterials(onlyVisible: $onlyVisible) {
        id
        title
        visible
        selectable
        children {
          id
          title
          visible
          selectable
          parentId
          children {
            id
            title
            visible
            selectable
            parentId
            children {
              id
              title
              visible
              selectable
              parentId
              children {
                id
                title
                visible
                selectable
                parentId
              }
            }
          }
        }
      }
    }
  `,
}

export const mutations = {
  sortingOutputMaterialCreate: `
    mutation sortingOutputMaterialCreate($title: String!, $parentId: Int) {
      sortingOutputMaterialCreate(title: $title, parentId: $parentId) {
        id
      }
    }
  `,
  sortingOutputMaterialShowHide: `
    mutation sortingOutputMaterialShowHide($id: Int!) {
      sortingOutputMaterialShowHide(id: $id) { id }
    }
  `,
  sortingOutputMaterialSelectable: `
    mutation sortingOutputMaterialSelectable($id: Int!) {
      sortingOutputMaterialSelectable(id: $id) { id }
    }
  `,
  sortingOutputMaterialTreeUpdate: `
    mutation sortingOutputMaterialTreeUpdate(
      $dragedElement: Int!
      $targetElement: Int!
      $isIndentElement: Boolean!
      $childrenIds: [Int]!
    ) {
      sortingOutputMaterialTreeUpdate(
        dragedElement: $dragedElement
        targetElement: $targetElement
        isIndentElement: $isIndentElement
        childrenIds: $childrenIds
      ) { id }
    }
  `,
  sortingOutputMaterialUpdateTitle: `
    mutation sortingOutputMaterialUpdateTitle($id: Int!, $title: String!) {
      sortingOutputMaterialUpdateTitle(id: $id, title: $title) { id }
    }
  `,
  sortingOutputMaterialDelete: `
    mutation sortingOutputMaterialDelete($id: Int!) {
      sortingOutputMaterialDelete(id: $id)
    }
  `,
}

export const getSortingOutputMaterials = restHelper<SortingOutputMaterial[], object>(
  queries, "sortingOutputMaterials"
)

export const postSortingOutputMaterial = restHelper<SortingOutputMaterial, PostSortingOutputMaterialInput>(
  mutations, "sortingOutputMaterialCreate"
)

export const showHideSortingOutputMaterial = restHelper<boolean, ID>(
  mutations, "sortingOutputMaterialShowHide"
)

export const setSelectableSortingOutputMaterial = restHelper<boolean, ID>(
  mutations, "sortingOutputMaterialSelectable"
)

export const putSortingOutputMaterialTree = restHelper<SortingOutputMaterial, UpdateTreeDragAndDropInput>(
  mutations, "sortingOutputMaterialTreeUpdate"
)

export const putSortingOutputMaterialTitle = restHelper<SortingOutputMaterial, PutSortingOutputMaterialTitleInput>(
  mutations, "sortingOutputMaterialUpdateTitle"
)

export const deleteSortingOutputMaterial = restHelper<boolean, DeleteSortingOutputMaterialInput>(
  mutations, "sortingOutputMaterialDelete"
)
